import React from "react";
import { Input, PhoneInput, Checkbox } from "../../ui/input";
import RadioGroup from "../../ui/radio-group";
import FormLayout from "../form-layout";

const HomeForm = ({ methods, handleSubmit }) => {
  return (
    <FormLayout methods={methods} onSubmit={handleSubmit}>
      <RadioGroup
        name="status"
        elements={[
          {
            label: "I want funding now",
            value: "0",
            required: true,
          },
          {
            label: "I want funding in the future",
            value: "1",
            required: true,
          },
          {
            label: "Learn more",
            value: "2",
            required: true,
          },
        ]}
      />
      <Input
        id="id-name"
        name="name"
        label="Name"
        type="text"
        placeholder="Your Name..."
        validation={{
          required: `Required`,
          pattern: {
            value: /^[\p{L}\s']+$/u,
            message: `Names can only contain alphabets, letters, spaces, and apostrophes.`,
          },
          minLength: {
            value: 3,
            message: `Name must be at least 3 characters long.`,
          },
        }}
      />
      <Input
        id="id-email"
        name="email"
        label="Email"
        type="email"
        placeholder="Your Email..."
        validation={{
          required: "Required",
          pattern: {
            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: "Please enter a valid email address.",
          },
        }}
      />
      <PhoneInput
        id="id-phone"
        name="phone"
        label="Phone"
        type="text"
        placeholder="(999) 999-9999"
        validation={{
          required: "Phone number is required",
        }}
      />
      <Checkbox
        name="subscribe"
        label="By clicking here you opt-in to occasional SMS messages for communication purposes"
        id="newsletter-checkbox"
        defaultChecked={false}
      />
    </FormLayout>
  );
};

export default HomeForm;
